import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '@src/components/Loader';
import { AuthContext } from '@src/contexts/AuthContextProvider';
import { fetchAccessToken, getPermittedRoute, isAuthenticated } from '@src/lib/helper';
import { RouteComponentType } from '@src/lib/types';
import { getCookie } from '@src/utils/getCookie';

const RestrictedRoute = ({ component: Component }: RouteComponentType) => {
  const { headers, accessToken, userDetail } = useContext(AuthContext);
  const [authPassed, setAuthPassed] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      if (!getCookie('access_token') && getCookie('refresh_token')) {
        fetchAccessToken().then(data => setAuthPassed(data));
      } else {
        setAuthPassed(false);
      }
    } else {
      setAuthPassed(true);
    }
  }, [accessToken]);

  if (typeof authPassed === 'boolean') {
    if (!authPassed) {
      return <Component />;
    }

    const redirectionRoute = localStorage.getItem('redirectionRoute');

    if (redirectionRoute) {
      localStorage.removeItem('redirectionRoute');
      return <Navigate to={redirectionRoute} replace />;
    }

    return <Navigate to={getPermittedRoute(headers, userDetail)} replace />;
  }

  return <Loader />;
};

export default RestrictedRoute;
